import { Heading, Text, HStack } from '@genial/components';
import { Spacing, Typography } from '@genial/design-tokens';
import React from 'react';

import { ButtonRefresh } from '../ButtonRefresh';

export namespace HeaderSectionTypes {
  export interface Props {
    isMobile?: boolean;
    title: string;
    onRefresh?: () => void;
    updatedAt?: Date;
  }
}

export const HeaderSection: React.FC<HeaderSectionTypes.Props> = ({
  isMobile,
  title,
  onRefresh,
  updatedAt,
}) => {
  return (
    <>
      <HStack
        mt={!isMobile ? Spacing['inset.sm'] : 0}
        paddingBottom={Spacing['inset.xxxs']}
        justifyContent="space-between"
        alignItems="center"
        space={Spacing['inline.xxxs']}>
        <HStack
          width="100%"
          alignContent="center"
          justifyContent="center"
          alignItems="center"
          space={Spacing['inset.nano']}>
          {isMobile ? (
            <HStack
              alignItems="center"
              justifyContent="space-between"
              width="100%"
              marginTop={Spacing['inset.xs']}
              marginBottom={Spacing['inline.xxs']}>
              <Text
                paddingLeft={Spacing['inset.nano']}
                textAlign="center"
                color="brand.primary.principal"
                fontWeight={Typography['fontweight.semibold']}
                fontSize={Typography['fontsize.xl']}
                variant="semibold">
                {title}
              </Text>

              <ButtonRefresh onRefresh={onRefresh} updatedAt={updatedAt} />
            </HStack>
          ) : (
            <Heading
              testId="qa"
              size="h2"
              width="100%"
              paddingBottom={Spacing['inset.xs']}
              alignContent="center"
              alignItems="center"
              justifyContent="space-between">
              {title}
            </Heading>
          )}
        </HStack>
      </HStack>
    </>
  );
};
